export default {
    actions: {
        LoadCountries(ctx, data) {
            axios({
                method: 'GET',
                url: data.path + '/countries',
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    ctx.commit('updateCountries', response.data);
                }).catch(error => {})
        },
    },
    mutations: {
        updateCountries(state, data) {
            state.countries = data
        },
    },
    state: {
        countries: [],
    },
    getters: {
        getCountries(state) {
            return state.countries
        },
    }
}
